/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { RequestHistory } from '../../workflow/my-requests/commons/interfaces/my-requests.interface';
import { Employee } from 'src/app/workflow/benefits/commons/interfaces/benefit-body.interface';
import { Requests } from '../models/request.interface';
import { UtilsNotificationService } from 'src/app/utils/utils-notification.service';
import { FORM_TYPE_KEY } from 'src/app/workflow/benefit-application/utils/constants/constats';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  data: Employee[] = [];
  data_request_historical: RequestHistory[]=[]

  constructor(
    private httpClient: HttpClient,
    private utilsnotificationService: UtilsNotificationService,
  ) { }

  async getRequestAdministrator(): Promise<any[]> {
    const response = await firstValueFrom(
      this.httpClient.get<any[]>(enviroment.url + 'solicitudes/administrador'),
    );
    const mappedResponse: any[] = response.map((item) => {
      const creation_date = this.utilsnotificationService.formatDate(new Date(item.createdAt));
      const date_update = item.updatedAt != null ? this.utilsnotificationService.formatDate(new Date(item.updatedAt)) :
        '';
      return {
        benefit: item.typedata.descripcion,
        id_benefit: item.typedata.id,
        idCode: item.id,
        updatedAt: date_update,
        userId: item.userId,
        status: item.statusRequest,
        createdAt: creation_date,
        email: item.email,
        idrequest: item.idrequest,
        name: `${item.usernameRequest} ${item.SurnameRequest}`,
        rut: item.identification
      };
    });

    return mappedResponse;
  }

  async get_requests_pending_approval(): Promise<any[]> {
    const response = await firstValueFrom(
      this.httpClient.get<any[]>(enviroment.url + 'solicitudes/pendientes_aprobacion'),
    );
    const mappedResponse: any[] = response.map((item) => {
      const creation_date = this.utilsnotificationService.formatDate(new Date(item.createdAt));
      const date_update = item.updatedAt != null ? this.utilsnotificationService.formatDate(new Date(item.updatedAt)) : '';

      const first_approval_user = item.approvals[0]?.usuario_id
      const first_approval_date = item.approvals[0]?.fecha

      const second_approval_user = item.approvals[1]?.usuario_id == undefined ? '' : item.approvals[1]?.usuario_id
      const second_approval_date = item.approvals[1]?.fecha == undefined ? '' : item.approvals[1]?.fecha

      return {
        benefit: item.typedata.descripcion,
        idbenefit: item.typedata.id,
        idCode: item.id,
        updatedAt: date_update,
        userId: item.userId,
        status: item.statusRequest,
        createdAt: creation_date,
        email: item.email,
        idrequest: item.idrequest,
        name: `${JSON.parse(item.requestdata)["informacion_personal"]["Nombres"]["valor"]} ${JSON.parse(item.requestdata)["informacion_personal"]["Apellidos"]["valor"]} `,
        rut: item.identification,
        request_data: item.requestdata,
        first_approval_user: first_approval_user,
        first_approval_date: first_approval_date,
        second_approval_user: second_approval_user,
        second_approval_date: second_approval_date
      };
    });

    return mappedResponse;
  }

  async getRequestUser(): Promise<RequestHistory[]> {
    const response = await firstValueFrom(
      this.httpClient.get<any[]>(enviroment.url + 'solicitudes/usuario'),
    );

    const mappedResponse: RequestHistory[] = response.map((item) => {
      const requestData = JSON.parse(item.requestdata);
      const creation_date = this.utilsnotificationService.formatDate(new Date(item.createdAt));
      const date_update = item.updatedAt != null ? this.utilsnotificationService.formatDate(new Date(item.updatedAt)) :
        '';
      let nombre_titular = ''
      let rut = ''
      
      if (requestData.formulario === 'SOLICITUD_COLECTIVA_TRABAJADOR') {
        nombre_titular = requestData.tabla_datos[0]["Nombre Titular"]
        rut = requestData.tabla_datos[0]["Rut Titular"]
      }

      if (requestData.formulario !== 'SOLICITUD_COLECTIVA' && requestData.formulario !== 'SOLICITUD_COLECTIVA_TRABAJADOR' && requestData.formulario !== 'FRM_CAMBIO_PLAN' && requestData.formulario !== 'FRM_SALUD_DENTAL') {
        nombre_titular = `${requestData.informacion_personal.Nombres.valor} ${requestData.informacion_personal.Apellidos.valor}`
        rut = requestData.informacion_personal.RUT.valor
      }
      
      if (requestData.formulario === 'FRM_CAMBIO_PLAN' || requestData.formulario === 'FRM_SALUD_DENTAL') {
        nombre_titular = `${requestData.informacion_personal.Nombres.valor} ${requestData.informacion_personal.Apellido_Paterno.valor}`
        rut = requestData.informacion_personal.RUT.valor
      }

      return {
        benefit: item.typedata.descripcion,
        id_benefit: item.typedata.id,
        idCode: item.id,
        updatedAt: date_update,
        userId: item.userId,
        status: item.statusRequest,
        createdAt: creation_date,
        idrequest: item.idrequest,
        requestData: requestData,
        name: nombre_titular,
        rut: rut
      };
    });

    return mappedResponse;
  }

  getRequestId() {
    return this.data[0].identification;
  }

  setEmployee(data: Employee[]): void {
    this.data = data;
  }

  async getRequestById(id: string): Promise<any[]> {
    return firstValueFrom<any[]>(
      this.httpClient.get<any[]>(enviroment.url + 'requestById/' + id),
    );
  }

  async putRequests(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'request', element),
    );
  }

  async postRequests(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'request', element),
    );
  }

  async getRequestByEmail(email: string): Promise<Requests[]> {
    return firstValueFrom<Requests[]>(
      this.httpClient.get<Requests[]>(
        enviroment.url + 'getRequestByEmail/' + email,
      ),
    );
  }

  async post_requests_second_approver(payload: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'solicitud/aprobacion_masiva', payload),
    );
  }

  async getRequestLastUser(UserId: string): Promise<Requests[]> {
    return firstValueFrom<Requests[]>(
      this.httpClient.get<Requests[]>(
        enviroment.url + 'RequestLastUser/' + UserId,
      ),
    );
  }

  async cambiar_estado_solicitud(solicitud_id: Number): Promise<any> {
    const payload = {
      "id": solicitud_id
    }
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'solicitud/cambio_estado', payload),
    );
  }

  async get_beneficiarios_solicitud_beneficio(beneficio_id: Number, formulario: string = "SF"): Promise<any> {
    if (beneficio_id == 8) formulario = FORM_TYPE_KEY.FRM_AYUDA_ESPECIAL_REEMBOLSO;
    if (beneficio_id == 39) formulario = FORM_TYPE_KEY.FRM_FONDO_DEPORTISTA_REEMBOLSO;    
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + `solicitud/beneficio/${beneficio_id}/${formulario}/beneficiarios`),
    );
  }

  getRequestMemory() {
    return this.data_request_historical;
  }

  setRequestMemory(data_request_historical: RequestHistory[]): void {
    this.data_request_historical = data_request_historical;
  }

  async post_historial_solicitudes_usuario(datos_consulta: any): Promise<any> {
  const response = await firstValueFrom(
    this.httpClient.post<any[]>(
      enviroment.url + 'solicitudes/historial/usuario', datos_consulta
    ),
  );
  
  const formated_response: any[] = response.map((item) => {
      const fecha_creacion = this.utilsnotificationService.formatDate(new Date(item.createdAt));
      const fecha_actualizacion = item.updatedAt != null ? this.utilsnotificationService.formatDate(new Date(item.updatedAt)) :
        '';
      return {
        benefit: item.typedata.descripcion,
        id_benefit: item.typedata.id,
        idCode: item.id,
        updatedAt: fecha_actualizacion,
        userId: item.userId,
        status: item.statusRequest,
        createdAt: fecha_creacion,
        email: item.email,
        idrequest: item.idrequest,
        name: `${item.usernameRequest} ${item.SurnameRequest}`,
        rut: item.RUT
      };
    });
    
    return formated_response;
  
}

}
